import React from 'react';

const AnswerSection = ({ code, error }) => {
  // Utility: Strip backticks and language name
  const cleanCode = (rawCode) => {
    if (!rawCode) return '';
    return rawCode
      .replace(/^```[a-zA-Z]*\n?/, '') // Remove opening ``` and optional language (like ```cpp\n)
      .replace(/```$/, '')             // Remove trailing ```
      .trim();
  };

  return (
    <div className="mt-8">
      <div className="bg-gray-900 text-green-300 rounded-xl p-6 shadow-lg overflow-auto max-h-[400px] border border-gray-700 transition-all duration-300">
        {error ? (
          <p className="text-red-400 font-semibold">{error}</p>
        ) : code ? (
          <pre className="whitespace-pre-wrap break-words text-sm font-mono leading-relaxed">
            <code>{cleanCode(code)}</code>
          </pre>
        ) : (
          <p className="text-gray-400 italic">Generated code will appear here...</p>
        )}
      </div>
    </div>
  );
};

export default AnswerSection;
